const productRoute = window.location.pathname.match(/products-v2/) ? 'products-v2' : 'products'
const checkoutRoute = window.location.pathname.match(/checkout-v2/) ? 'checkout-v2' : 'checkout'

export const SHIPPING_SCROLL_ANCHORS = {
  address: 'address',
  method: 'method',
}

export const PAYMENT_SCROLL_ANCHORS = {
  address: 'address',
  method: 'method',
}

export default {
  checkout: checkoutRoute,
  checkoutRegistration: 'registration',
  checkoutRegistrationAliases: ['cart'],
  checkoutShipping: 'shipping',
  checkoutShippingAliases: ['address', 'delivery'],
  checkoutPayment: 'payment',
  checkoutPaymentAliases: ['confirm'],
  checkoutConfirmation: 'confirmation',
  pageNotFound: '404',
  serverError: '500',
  unprocessableEntity: '422',
  cyclon: 'cyclon',
  comparison: 'comparison',
  onStore: 'on-store',
  onStoreNYC: 'nyc',
  product: productRoute,
  roger: 'theroger',
  home: 'home',
  npsFeedback: 'nps-feedback',
  ownerCardRegistration: 'owner-card',
  productReviews: 'product-reviews',
  raffleEntryUpdate: 'raffle/update-entry',
  raffleEntryCreate: 'raffle/create-entry',
  raffleConfirmation: 'raffle/confirmation',
  shoeFinder: 'shoe-finder',
  demo: 'demo',
  demoForm: 'demo-form',
  demoSizing: 'demo-sizing',
  demoDyApi: 'demo-dy-api',
}
